import { useCallback, useMemo } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import ContractService from "services/Contract";
import _ContractModal from "routes/entity/components/ContractModal";
import { useContractsTable } from "hooks/useContractsTable";
import { omitByNil } from "helpers/tables";

export const CONTRACTS_TABLE_CONSTANTS = {
  tableName: "contracts",
  className: "Contract",
  exportTableName: null,
  header: "Contracts",
  headerIcon: "building",
};

const NewContractModal = withRoleCheck(_ContractModal, [
  ACL_RELATIONSHIPS.contract.create,
  ACL_RELATIONSHIPS.contractForFilters.read,
]);

const ContractsTableV3 = ({ entityId = null }) => {
  const defaultQueryParams = useMemo(
    () =>
      omitByNil({
        entity_id: entityId,
      }),
    [entityId]
  );
  const { filters, columns, customFields, queryKey, invalidateData } =
    useContractsTable({
      entityId,
    });

  const fetchContracts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await ContractService.getContracts({
          ...nextQueryParams,
          ...defaultQueryParams,
        });

        return response;
      } catch (error) {
        console.error("Error fetching contracts:", error);
        throw error;
      }
    },
    [columns, defaultQueryParams]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      customFields={customFields ?? []}
      headerIcon={CONTRACTS_TABLE_CONSTANTS.headerIcon}
      header={CONTRACTS_TABLE_CONSTANTS.header}
      queryKey={queryKey}
      className={CONTRACTS_TABLE_CONSTANTS.className}
      tableName={CONTRACTS_TABLE_CONSTANTS.tableName}
      enableSearch
      enableSettings
      createButton={
        <NewContractModal onSuccess={invalidateData} entityId={entityId} />
      }
      fetchData={fetchContracts}
      invalidateData={invalidateData}
    />
  );
};

export default ContractsTableV3;
